<template>
  <v-alert
    :icon="false"
    dense
    v-if="message"
    :color="config.background"
    :class="classes"
  >
    <template>
      <v-icon :color="config.errorIcon">
        mdi-alert-circle-outline
      </v-icon>
    </template>
    <span class="text--primary body-2">
      {{ message }}
    </span>
  </v-alert>
</template>
<script>
/**
 *  Alert Message Component
 */
export default {
  name: "AlertMessage",
  /**
   * ------- Props attributes -------
   */
  props: {
    /**
     * Message to be shown in the alert
     */
    message: { type: String, default: null },
    /**
     * Alert message classes
     */
    classes: { type: String, default: "py-3" },
    /**
     * Type of the alert message to be shown
     * @values info,error
     */
    type: { type: String, default: "error", required: true },
  },
  /**
   * ----------------- Computed properties -----------------
   */
  computed: {
    /**
     * Alert message config on the basis of the type prop
     * @description Computes the config of the alert on the basis of its type
     * @type {Object}
     * @returns {Object} Alrt message configuration
     */
    config() {
      const { types, colors } = this.$appConfig.alert;

      switch (this.type) {
        case types.info:
          return { background: colors.info, icon: colors.infoIcon };
        case types.error:
          return { background: colors.error, icon: colors.errorIcon };
        default:
          return { background: colors.info, icon: colors.infoIcon };
      }
    },
  },
};
</script>
